import { Button, LoadingButton } from '@zarya/ui';
import { t, tn } from '@app/i18n';
import s from './AccessControl.module.css';

export interface DirtyFooterProps {
  /** Quantas mudanças em relação ao contrato vigente. */
  mudancas: number;
  /** Versão do contrato vigente — aparece no texto de "sem mudanças". */
  contratoVersion: number;
  /** Há limite inválido em alguma tool concedida. */
  invalido: boolean;
  enviando: boolean;
  /** `false` para viewer: o rodapé some inteiro (FR-010). */
  podeSalvar: boolean;
  onDescartar: () => void;
  onSalvar: () => void;
}

/**
 * Rodapé do rascunho (FR-077): **Salvar → enviar para aprovação** desabilitado
 * sem mudança, o contador de mudanças não salvas e **descartar**.
 *
 * O botão fica desabilitado (não omitido) quando não há mudança: é feedback do
 * formulário, não permissão. Quem não pode salvar não vê o rodapé.
 */
export function DirtyFooter({
  mudancas,
  contratoVersion,
  invalido,
  enviando,
  podeSalvar,
  onDescartar,
  onSalvar,
}: DirtyFooterProps) {
  if (!podeSalvar) return null;

  const sujo = mudancas > 0;

  return (
    <div className={s.rodape}>
      <span className={s.rodapeTexto}>
        {sujo ? (
          <span className={s.rodapeSujo}>{tn('identityAccess.footer.unsaved', mudancas)}</span>
        ) : (
          t('identityAccess.footer.clean', { version: contratoVersion })
        )}
        {invalido ? t('identityAccess.footer.invalid') : ''}
      </span>

      {sujo ? (
        <Button variant="out" onClick={onDescartar} disabled={enviando}>
          {t('identityAccess.footer.discard')}
        </Button>
      ) : null}

      <LoadingButton
        icon="check"
        loading={enviando}
        loadingLabel={t('identityAccess.footer.saving')}
        disabled={!sujo || invalido}
        onClick={onSalvar}
      >
        {t('identityAccess.footer.save')}
      </LoadingButton>
    </div>
  );
}
